import { Route } from 'react-router-dom'

import ProfileMiddleware from '../middlewares/ProfileMiddleware'
import MaybeProfileMiddleware from '../middlewares/MaybeProfileMiddleware'

import PageAddpost from '../pages/tabs/Addpost/PageAddpost'
import PageShowPost from '../pages/post/ShowPost/PageShowPost'
import PageEditpost from '../pages/post/Editpost/PageEditpost'
import PageStatsPost from '../pages/post/Statspost/PageStatsPost'

export const RoutesPost = [
    <Route
        path="/post/:idUser/:idPost" element={<MaybeProfileMiddleware><PageShowPost /></MaybeProfileMiddleware>}
        key="route-u-post" />,
    <Route path="/post/create" element={<ProfileMiddleware><PageAddpost /></ProfileMiddleware>} key="route-u-post-add" />,
    <Route path="/post/edit/:globalPostId" element={<ProfileMiddleware><PageEditpost /></ProfileMiddleware>} key="route-u-post-edit" />,
    <Route path="/post/stats/:globalPostId" element={<ProfileMiddleware><PageStatsPost /></ProfileMiddleware>} key="route-u-post-edit" />,
]
